<template>
  <div class="editor">
    <div ref="toolbar" class="toolbar"></div>
    <div ref="editor" class="text"></div>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
const E = process.browser ? require("wangeditor") : undefined;
export default {
  name: "MyEditor",
  data() {
    return {
      editor: null,
      info_: null,
      isChange: false
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    isClear: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // value: function(value) {
    //   if (value !== this.editor.txt.html()) {
    //     this.editor.txt.html(this.value);
    //   }
    // }
    value: function() {
      if (!this.isChange) {
        this.editor.txt.html(this.value);
      }
      this.isChange = false;
    }
  },
  mounted() {
    this.setEditor();
    this.editor.txt.html(this.value);
  },
  components: {},
  methods: {
    setEditor() {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      this.editor.customConfig.uploadImgMaxSize = 20 * 1024 * 1024;
      this.editor.customConfig.customUploadImg = (files, insert) => {
        const formData = new FormData();
        formData.append("file", files[0]);
        this.axios.post("/game/imgUpload", formData).then(resp => {
          if (resp) {
            const url = resp.data;
            insert(url);
            this.$message.success("图片上传成功");
          }
        });
      };
      // 配置菜单
      this.editor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
        "fullscreen" // 全屏
      ];
      this.editor.customConfig.onchange = html => {
        this.isChange = true;
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.editor.create();
    }
  }
};
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
.w-e-toolbar {
  flex-wrap: wrap;
}
.toolbar {
  border: 1px solid #ccc;
  border-radius: 5px;
}
.text {
  border: 1px solid #ccc;
  overflow-y: auto;
  height: 335px;
  border-radius: 5px;
}
</style>
